import { httpGet } from "../api/chatHttp";
import { Message, MessageDataPayload, AttachmentPackage, AttachmentData } from "../../data/chat";

async function getMessagesAction(prevLength: number, onSuccess: (messages: Message[]) => void, onError: (msg: string) => void) {
  try {
    const data: Message[] = await httpGet<Message[]>('/api/GetMessageHistory/');

    for (let i = prevLength > 0 ? prevLength - 1 : 0; i < data.length; i++){
      if (data[i].AttachmentPackage != undefined){
        //console.log(data[i].AttachmentPackage);
        await downloadAttachmentData(data[i].AttachmentPackage, (attachments: AttachmentData[]) => {
          let messageIndex = data.findIndex((m: any) => m.Id == data[i].Id);
          data[messageIndex].Attachments = attachments;
        },(msg: string) => {
          //
        })
      }
    }
    const sortData = data ? data.sort((messageA: Message, messageB: Message) => {
      return messageA.CreatedAt.valueOf() <= messageB.CreatedAt.valueOf() ? (messageA.CreatedAt.valueOf() == messageB.CreatedAt.valueOf() ? 0 : -1) : 1
    }) : [];

    onSuccess(sortData);
    return sortData;
  } catch (e) {
    onError((e as Error).message)
    return null;
  }
}

async function downloadAttachment(payload: string, onSuccess: (attachments: string) => void, onError: (msg: string) => void): Promise<string> {
  try {
    const data: string = await httpGet<string>(`/api/GetAttachmentByIdBase64?attachmentId=${payload}`);
    onSuccess(data);
    return data;
  } catch (e) {
    onError((e as Error).message)
    return null;
  }
}

async function downloadAttachmentData(payload: AttachmentPackage, onSuccess: (attachments: AttachmentData[]) => void, onError: (msg: string) => void): Promise<AttachmentData[]> {
  try {
    const data: AttachmentData[] = await httpGet<AttachmentData[]>(`/api/GetMessageAttachments?attachmentPackageId=${payload.Id}`);
    if (data != null){
      await downloadAttachment(data[0].Id,(img: string) =>{
        data[0].Content = img;
      }, () => {

      })
    }
    //console.log(data)
    onSuccess(data);
    return data;
  } catch (e) {
    onError((e as Error).message)
    return null;
  }
}
export {getMessagesAction, downloadAttachmentData}